import { deepEquals } from 'app/infrastructure/js';
import { linkCodesAction } from '../constants';
import { ListAction, ListBranch, ListBranchItem } from '../types-store';
import { mapInitialSelection, mapActionsToSelection } from './map-selection';

export const hasChanges = (
  listBranch: ListBranch[],
  listActions: ListAction[],
  initialValueSelected: (item: ListBranchItem) => boolean
) => {

  if (!listActions?.length || !listBranch?.length) {
    return false;
  }

  if (listActions.some(action => action.type === linkCodesAction.selectAll
    || action.type === linkCodesAction.deselectAll)) {
    return true;
  }
  
  const initialSelection = mapInitialSelection(listBranch, initialValueSelected);

  const selectionAfterActions = mapActionsToSelection(initialSelection, listActions);

  if (!deepEquals(initialSelection, selectionAfterActions)) {
    return true;
  }

  const affectedPaths = listActions
    .map(action => action.propagate ? action.path : undefined)
    .filter(path => path);

  const rootBranch = listBranch.find(branch => branch.id === 0);
  const rootBranchLoaded = !!rootBranch && rootBranch.numberOfResults === rootBranch.items.length;

  return affectedPaths.some(path => {

    if (path.length === 0 && !rootBranchLoaded) {
      return true;
    }

    return initialSelection.some(selection =>
      deepEquals(path, selection.path.slice(0, path.length)) && !selection.childrenLoaded
    );
  });
};
